
    import {Component, Vue} from 'vue-property-decorator';
    import Layout from '@/components/layout/Layout.vue';
    import TableComponent from '@/components/table/TableComponent.vue';

    @Component({
        components: {
            Layout,
            TableComponent,
        },
    })
    export default class ApplicationIndex extends Vue {
        private keys = {
            id: '#',
            name: 'Meno',
            surname: 'Priezvisko',
            street: 'Ulica',
            streetNumber: 'Číslo ulice',
            city: 'Mesto',
            'partner.name': 'Partner',
            note: 'Poznámka',
            status: 'Status',
            'card.number': 'Číslo karty',
            externalUid: 'Externé číslo',
            createdAt: 'Dátum vytvorenia'
        };

        private selects = {
            status: [
                'new',
                'approved',
                'denied',
                'anonymize',
                'anonymized',
                'cancelled'
            ],
        };

        private links = [
            {
                url: '/ziadosti/:param:',
                image: require('@/assets/image/edit.svg'),
            },
        ];

        private apiCall = 'getApplications';

        // toto funguje tak, ze ak je v stlpci s nazvom 'status' hodnota 'new', tak sa tam priradia prislusne classy
        private customColumnClass = {
            'status': {
                'new': {
                    'text-blue': true,
                    'font-bold': true
                },
                'approved': {
                    'text-green': true,
                    'font-bold': true
                },
                'denied': {
                    'text-red': true,
                    'font-bold': true
                },
                'cancelled': {
                    'text-gray': true,
                    'font-bold': true
                }
            }
        };
        
        private isexport = true;
    }
